export interface FooterUrls {
  hostLogin: string
  getStarted: string
  faqs: string
  helpCenter: string
  pricing: string
  privacy: string
  termsOfService: string
  hostTcs: string
  acceptableUsePolicy: string
}

export const footerUrlsByBrand: Record<string, FooterUrls> = {
  guestpix: {
    hostLogin: "https://my.guestpix.com",
    getStarted: "https://www.guestpix.com/guest",
    faqs: "https://help.guestpix.com",
    helpCenter: "https://help.guestpix.com",
    pricing: "https://www.guestpix.com/pricing",
    privacy: "https://www.guestpix.com/privacy-policy/",
    termsOfService: "https://guestpix.com/guest-terms-and-conditions",
    hostTcs: "https://guestpix.com/host-terms-and-conditions",
    acceptableUsePolicy: "https://guestpix.com/acceptable-use-policy",
  },
  honorpix: {
    hostLogin: "https://my.honorpix.com",
    getStarted: "https://my.honorpix.com/signup",
    faqs: "https://honorpix.com/faqs/",
    helpCenter: "https://help.honorpix.com",
    pricing: "https://honorpix.com/pricing/",
    privacy: "https://honorpix.com/privacy-policy",
    termsOfService: "https://honorpix.com/guest-terms-and-conditions/",
    hostTcs: "https://honorpix.com/host-terms-and-conditions",
    acceptableUsePolicy: "https://honorpix.com/acceptable-use-policy/",
  },
}

export const socialLinksByBrand: Record<string, Record<string, string>> = {
  guestpix: {
    instagram: "https://instagram.com/guestpix",
    facebook: "https://www.facebook.com/guestpixevents",
    pinterest: "https://pinterest.com/guestpix",
    tiktok: "https://www.tiktok.com/@guestpix",
    youtube: "http://www.youtube.com/@guestpix",
  },
  honorpix: {
    facebook: "https://www.facebook.com/honorpix",
    instagram: "https://www.instagram.com/honorpix/",
    linkedIn: "https://www.linkedin.com/showcase/honorpix/",
    tiktok: "https://www.tiktok.com/@honorpixhq",
  },
}

export const supportEmailByBrand: Record<string, string> = {
  guestpix: "customercare@guestpix.com",
  honorpix: "customercare@honorpix.com",
}

export function getBrandFooterUrls(brand: string = import.meta.env.VITE_BRAND || "guestpix"): FooterUrls {
  return footerUrlsByBrand[brand] ?? footerUrlsByBrand.guestpix
}

export function getBrandSocialLinks(brand: string = import.meta.env.VITE_BRAND || "guestpix"): Record<string, string> {
  return socialLinksByBrand[brand] ?? socialLinksByBrand.guestpix
}

export function getBrandSupportEmail(brand: string = import.meta.env.VITE_BRAND || "guestpix"): string {
  return supportEmailByBrand[brand] ?? supportEmailByBrand.guestpix
}

export function getBrandName(appName: string = import.meta.env.VITE_APP_NAME): string {
  return appName || "GUESTPIX"
}
